import { BACKEND_URL } from "../constants";

export const getPatientSampleId = (patient) => patient?.sample_id || "";

export const printReportUrl = (sampleId) =>
  `${BACKEND_URL}report-print/${encodeURIComponent(sampleId)}?key=c4ca4238a0b923820dcc509a6f75849b`;

export const printNewReportUrl = (sampleId) =>
  `${BACKEND_URL}new-report-print/${encodeURIComponent(sampleId)}?key=c4ca4238a0b923820dcc509a6f75849b`;

export const printInvoiceUrl = (sampleId) =>
  `${BACKEND_URL}invoice-print/${encodeURIComponent(sampleId)}`;

export const printPatientDetailUrl = (sampleId) =>
  `${BACKEND_URL}patient-detail/${encodeURIComponent(sampleId)}`;

export const reportEditUrl = (sampleId) =>
  `/report-edit?sample_id=${encodeURIComponent(sampleId)}`;

export const patientEditUrl = (sampleId) =>
  `/patient/edit/${encodeURIComponent(sampleId)}`;

export const patientDuplicateUrl = (sampleId) =>
  `/patient/duplicate/${encodeURIComponent(sampleId)}`;

/** Read sample_id from report-edit URL (?sample_id=, legacy ?mr=). */
export const sampleIdFromSearch = (search) => {
  const params = new URLSearchParams(search);
  return params.get("sample_id") || params.get("mr") || "";
};

/** Replace legacy ?mr= with ?sample_id= in the address bar. */
export const normalizeReportEditSearchUrl = (history, search) => {
  const params = new URLSearchParams(search);
  const legacyMr = params.get("mr");
  if (!legacyMr || params.get("sample_id")) {
    return;
  }
  history.replace(reportEditUrl(legacyMr));
};
